import * as React from 'react'
import './BrandDetailAdditionalOption.scss'
import Option from '../../models/option'
import { DictionaryValue } from '../../components/dictionary-value'

type Props = {
    className: string
    title: JSX.Element | string
    items: Option[] | undefined
    url: string | undefined
}

class BrandDetailAdditionalOption extends React.Component<Props> {
    render() {
        const { className, title, items, url } = this.props
        const refer = <DictionaryValue token='brand.detail.option.refer.to.our' />
        const website = <DictionaryValue token='brand.detail.option.website' />

        return (
            <div className={`brand-detail-additional-option ${className}`}>
                <h2 className='brand-detail-additional-option__title'>{title}</h2>
                {items === undefined ||
                    <div className='brand-detail-additional-option__option-wrapper'>
                        { items.map((item: Option) =>
                            <div
                                className='brand-detail-additional-option__option'
                                key={item.slug}
                            >
                                <img
                                    className='brand-detail-additional-option__option-image'
                                    src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAABnRSTlMA/
                                    wD/AP83WBt9AAAADElEQVQI12P4//8/AAX+Av7czFnnAAAAAElFTkSuQmCC'
                                    data-blink-src={item.logo}
                                    alt={item.name}
                                />
                            </div>
                        )}
                    </div>
                }
                {url === undefined ||
                    <div className='brand-detail-additional-option__link-wrapper'>
                        {refer} <a
                            className='brand-detail-additional-option__link'
                            href={url}
                            target='_blank'
                        >
                            {website}
                        </a>
                    </div>
                }
            </div>
        )
    }
}

export default BrandDetailAdditionalOption
